// extracted by mini-css-extract-plugin
module.exports = {"main":"faqs-module--main--2o2aA","faqItem":"faqs-module--faq-item--dmima","faqItemBody":"faqs-module--faq-item-body--2qI5G","collapsed":"faqs-module--collapsed--30n-z"};